import { PROD_ENVS } from 'constants/envs';

/**
 * Environments allowed to write missing i18n keys: 'dev' plus all prod envs.
 *
 * Sourced from app/constants/envs.ts so new regions are picked up automatically.
 */
export const LOCIZE_SAVE_MISSING_ENV_ALLOWLIST: string[] = [
  'dev',
  ...PROD_ENVS,
];

export const shouldSaveMissingToProduction = (
  environment?: string,
): boolean => {
  const normalizedEnvironment = (environment || '').toLowerCase();

  if (!normalizedEnvironment) {
    return false;
  }

  return LOCIZE_SAVE_MISSING_ENV_ALLOWLIST.includes(normalizedEnvironment);
};
